const RentAdjustmentSummaryFilterStyle = ({ unitMultiSelect: { height: '250px' } });

export default RentAdjustmentSummaryFilterStyle;
